export default {"src":"/_next/static/media/ai.b88f3351.svg","height":16,"width":19,"blurWidth":0,"blurHeight":0};